/**
 * The API returns errors as `{ error: "<message>" }` with a 4xx/5xx status (see the backend's
 * JsonExceptionFilter). `request` rejects with the raw `Response`, so callers that want to show the
 * server's human-readable message must read the body themselves. This centralizes that extraction.
 */
export async function getResponseErrorMessage(err: unknown, fallback: string): Promise<string> {
    if (err instanceof Response) {
        try {
            const data = await err.json();
            if (typeof data?.error === 'string' && data.error) {
                return data.error;
            }
        } catch {
            /* non-JSON body — fall through to the fallback message */
        }
    }
    return fallback;
}
